import { render } from "./ManageParkingSpots.vue?vue&type=template&id=0c2d7c38&scoped=true&ts=true"
import script from "./ManageParkingSpots.vue?vue&type=script&lang=ts"
export * from "./ManageParkingSpots.vue?vue&type=script&lang=ts"

import "./ManageParkingSpots.vue?vue&type=style&index=0&id=0c2d7c38&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2d7c38"]])

export default __exports__